const tmmasterBaseUrl = process.env.VUE_APP_API_URL_TMMASTER; // https://master.api.trademonki.com / http://localhost:9099
const noomproxyBaseUrl = process.env.VUE_APP_API_URL_NOOMPROXY; // https://noom.api.trademonki.com / http://localhost:9190
const noominuhkBaseUrl = process.env.VUE_APP_API_URL_NOOMINUHK; // https://noominuhk.api.trademonki.com / http://localhost:9095
const klemmergBaseUrl = process.env.VUE_APP_API_URL_KLEMMERG;

export { tmmasterBaseUrl, noomproxyBaseUrl, noominuhkBaseUrl, klemmergBaseUrl };
